import { createRouter, createWebHashHistory } from 'vue-router'
import Profile from './components/Profile.vue'
import Projects from './components/Projects.vue'
import Certificates from './components/Certificates.vue'
import Creatives from './components/Creatives.vue'

const routes = [
  {
    path: '/',
    name: 'About',
    component: Profile
  },
  {
    path: '/Projects',
    name: 'Projects',
    component: Projects
  },
    {
    path: '/Creatives',
    name: 'Creatives',
    component: Creatives
  },
  {
    path: '/Certificates',
    name: 'Certificates',
    component: Certificates
  },

]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes
})

export default router